





















































































































































































































































































































































































































































































































































































































    import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
    import iView from 'iview';
    import Ajax from '../../../lib/ajax'
    import AbpBase from '../../../lib/abpbase'
    import AppConst from '../../../lib/appconst';
import { type } from 'os';
    @Component({
        name:'contractAddForm'
    })
    export default class ContractAddForm extends AbpBase  {
        @Prop() mainContractData:Object;
        @Prop() editData:Object;
        @Prop() mainType:number;
        @Prop() contractId:number;
        initData:any = {
            formData: {
                contractCode: null,
                contractName: undefined,
                ownerUnit: undefined,
                fundsSource: undefined,
                blankContractCode: null,
                attachs: [],                
                startTimeOptions: {}, //开始日期设置
                endTimeOptions: {}, //结束日期设置
                area:[],
                isBackFormalContract:'false'
            },
            dicData: {
                bearerUnit: [],
                bearerOrg: [],
                allDic: {},
                needReverse: [1,2,4,5,6]
            },
            submitData: {},
            fileUrl: AppConst.fileUrl,            
            //fileUrl: 'http://183.230.255.39:9903',
            loading: true,
            wxProjectType: [], // 外协合同分类

        }
        //动态加载地区数据
        LoadArea(item:any, callback:any){
            item.loading = true;
            Ajax.get('/api/services/app/Region/GetProvinceOrCityRegionsById?input='+item.value).then((res:any)=>{
                item.children = res.data.result.children;
                item.loading = false;
                callback();
            })
        }
        //获取合同编号
        async GetContractCode() {
            this.initData.formData.contractCode = (await Ajax.post('/api/services/app/Contract/CreateContractCodeAsync', {belongId: this.initData.formData.belongOrgId})).data.result;
        }
        //设置开始时间
        StartTimeChange(e:any) { 
            this.initData.formData.beginDt = e;
            this.initData.formData.endTimeOptions = {
                disabledDate: (date:any) => {
                    let beginDt = this.initData.formData.beginDt ? new Date(this.initData.formData.beginDt).valueOf() : '';
                    return date && (date.valueOf() < beginDt);
                }
            }
        }
        //设置结束时间
        EndTimeChange(e:any) { 
            this.initData.formData.endDt = e;
            let endDt = this.initData.formData.endDt ? new Date(this.initData.formData.endDt).valueOf() - 1 * 24 * 60 * 60 * 1000 : '';
            this.initData.formData.startTimeOptions = {
                disabledDate(date:any) {
                    return date && date.valueOf() > endDt;
                }
            }
        }
        //删除文件
        async DeleteFile(res:any) {
            if(res.isFormal){
                //已有文件
                let data:any = {
                    ContractId: this.initData.formData.id,
                    FileId: res.fileId
                }
                await Ajax.delete('/api/services/app/Contract/DeleteContractAttachAsync', {params: data});
                this.initData.formData.attachsFormal.splice(this.initData.formData.attachsFormal.indexOf(res.fileId),1);
                (this.$parent.$parent as any).GetData();
            }else{
                //临时文件
                await Ajax.post('/api/File/DeleteTempFile?filename='+res.response.result);
                this.initData.formData.attachs.splice(this.initData.formData.attachs.indexOf(res.response.result), 1);
            }
        }
        //临时文件上传成功回调
        UploadSuccess(res:any, file:any, fileList:any) {
            this.initData.formData.attachs.push({
                attachName: res.result
            });
        }

        //提交数据
        async Submit(type:any) {
            (this.$refs.contractAddForm as any).validate(async (valid:boolean)=>{
                if(valid){
                    if(!this.initData.formData.isUnitPriceContract && !this.initData.formData.contractAmount && this.mainType != 1){
                        this.$Message.error('请填写合同金额!');
                        if(this.mainType == 3 || this.mainType == 5){
                            setTimeout(() => {
                                (this.$parent.$parent as any).AddAgreementModalClose(false);
                                this.$nextTick(() => {
                                    (this.$parent.$parent as any).AddAgreementModalClose(true);
                                });
                            }, 1000);
                        }else{
                            setTimeout(() => {
                                (this.$parent.$parent as any).AddModalClose(false);
                                this.$nextTick(() => {
                                    (this.$parent.$parent as any).AddModalClose(true);
                                });
                            }, 1000);
                        }
                        return;
                    }
                    this.initData.submitData = (this as any).$root.copyObj(this.initData.formData);
                    this.initData.submitData.isReportStamped = !!this.initData.submitData.isReportStamped;
                    this.initData.submitData.sealCount = this.initData.submitData.sealCount ? this.initData.submitData.sealCount : undefined;
                    this.initData.submitData.contractId = this.contractId ? this.contractId : this.initData.submitData.contractId;
                    this.initData.submitData.keepOnRecordDt = this.initData.submitData.keepOnRecordDt ? this.initData.submitData.keepOnRecordDt : null;
                    if(!this.initData.submitData.members || (this.initData.submitData.members && !this.initData.submitData.members[0].belongOrgUnit && !this.initData.submitData.members[0].memberName)){
                        this.initData.submitData.members = [];
                    }
                    //处理文件上传
                    if(this.initData.submitData.attachs && this.initData.submitData.attachs.length){
                        this.initData.submitData.attachs = this.initData.submitData.attachs.map((item:any)=>{
                            return item.attachName;
                        })
                    }else{
                        this.initData.submitData.attachs = [];
                    }
                    //this.initData.submitData.projectCatalogId = this.initData.submitData.projectCatalog;
                    //处理倒排工期
                    if(this.initData.submitData.fieldConstructionFinishDt){
                        this.initData.submitData.reverseSchedule = {};
                        this.initData.submitData.reverseSchedule.fieldConstructionFinishDt = this.initData.submitData.fieldConstructionFinishDt;
                        this.initData.submitData.reverseSchedule.fieldAcceptanceDt = this.initData.submitData.fieldAcceptanceDt;
                        this.initData.submitData.reverseSchedule.reportReviewFilingDt = this.initData.submitData.reportReviewFilingDt;
                        this.initData.submitData.reverseSchedule.dataExchangeDt = this.initData.submitData.dataExchangeDt;
                        this.initData.submitData.reverseSchedule.submitFinalAccountDt = this.initData.submitData.submitFinalAccountDt;
                    }
                    //项目所在地区
                    if(this.initData.formData.area){
                        this.initData.submitData.provinceId = this.initData.formData.area[0];
                        this.initData.submitData.cityId = this.initData.formData.area[1];
                        this.initData.submitData.countyId = this.initData.formData.area[2];
                    }
                    //区分合同大类别，特殊合同-1、主合同-2、补充协议-3、外协合同-4
                    let creatUrl:any = null,
                        editUrl:any = null,
                        toUrl:any = null;
                    if(this.mainType == 2){
                        if(!this.initData.submitData.countyId && !this.initData.submitData.provinceId && !this.initData.submitData.cityId){
                            this.$Message.error("请选择项目所在地区！");
                            return;
                        }
                        this.initData.submitData.isBackFormalContract = this.initData.submitData.isBackFormalContract == 'true' ? true : false;
                        creatUrl = '/api/services/app/Contract/CreateMainAsync';
                        editUrl = '/api/services/app/Contract/UpdateMainAsync';
                        toUrl = 'contractList';
                    }else if(this.mainType == 1){
                        this.initData.submitData.fundsSource = this.initData.submitData.fundsSource  == 0 ? null : this.initData.submitData.fundsSource;
                        creatUrl = '/api/services/app/Contract/CreateSpecialAsync';
                        editUrl = '/api/services/app/Contract/UpdateSpecialAsync';
                        toUrl = 'contractSpecialList';
                    }else if(this.mainType == 3){
                        if(!this.initData.submitData.countyId){
                            this.$Message.error("请选择项目所在地区！");
                            return;
                        }
                        this.initData.submitData.isBackFormalContract = this.initData.submitData.isBackFormalContract == 'true' ? true : false;
                        creatUrl = '/api/services/app/Contract/CreateSupplementAsync';
                        editUrl = '/api/services/app/Contract/UpdateSupplementAsync';
                        toUrl = 'contractAddAgreementList';
                    }else if(this.mainType == 4){
                        if(this.initData.submitData.attachs && this.initData.submitData.attachs.length < 1 ) {
                            if(this.initData.formData.attachsFormal == undefined || this.initData.formData.attachsFormal.length < 1) {
                                this.$Message.error("请上传附件！");
                                setTimeout(() => {
                                    (this.$parent.$parent as any).AddModalClose(false);
                                    this.$nextTick(() => {
                                        (this.$parent.$parent as any).AddModalClose(true);
                                    });
                                }, 1000);
                                return;
                            }
                        }
                        creatUrl = '/api/services/app/Contract/CreateExternalAsync';
                        editUrl = '/api/services/app/Contract/UpdateExternalAsync';
                        toUrl = 'contractOutsideList';
                    }else if(this.mainType == 5){
                        if(this.initData.submitData.attachs && this.initData.submitData.attachs.length < 1 ) {
                            if(this.initData.formData.attachsFormal == undefined || this.initData.formData.attachsFormal.length < 1) {
                                this.$Message.error("请上传附件！");
                                setTimeout(() => {
                                    (this.$parent.$parent as any).AddAgreementModalClose(false);
                                    this.$nextTick(() => {
                                        (this.$parent.$parent as any).AddAgreementModalClose(true);
                                    });
                                }, 1000);
                                return;
                            }
                        }
                        creatUrl = '/api/services/app/Contract/CreateSupplementAsync';
                        editUrl = '/api/services/app/Contract/UpdateSupplementAsync';
                        toUrl = 'contractOutsideList';
                    }
                    if(type == 'edit'){
                        await Ajax.put(editUrl, this.initData.submitData)
                                  .then( (res: any) => {
                                        this.$Message.success('修改成功！');
                                        (this.$parent.$parent as any).CloseAddModal(false);
                                        (this.$parent.$parent as any).GetData();
                                  } )
                                  .catch( (err: any) => {
                                        if(this.mainType == 3){
                                            setTimeout(() => {
                                                (this.$parent.$parent as any).AddAgreementModalClose(false);
                                                this.$nextTick(() => {
                                                    (this.$parent.$parent as any).AddAgreementModalClose(true);
                                                });
                                            }, 1000);
                                        }else{
                                            setTimeout(() => {
                                                (this.$parent.$parent as any).AddModalClose(false);
                                                this.$nextTick(() => {
                                                    (this.$parent.$parent as any).AddModalClose(true);
                                                });
                                            }, 1000);
                                        }
                                  } )
                        
                    }else{
                        await Ajax.post(creatUrl, this.initData.submitData);
                        if(this.mainType == 3 || this.mainType == 5){
                            this.$Message.success('提交成功！');
                            (this.$parent.$parent as any).CloseAddAgreementModal(false);
                            (this.$parent.$parent as any).GetData();
                        }else{
                            this.$Modal.success({
                                title: '合同登记',
                                content: '合同登记申请已提交，待审核通过后，即可分配合同编号',
                                onOk: ()=>{
                                    this.$router.push({name: toUrl})
                                }
                            });
                        }
                    }
                }else{
                    if(this.mainType == 3 || this.mainType == 5){
                        setTimeout(() => {
                            (this.$parent.$parent as any).AddAgreementModalClose(false);
                            this.$nextTick(() => {
                                (this.$parent.$parent as any).AddAgreementModalClose(true);
                            });
                        }, 1000);
                    }else{
                        setTimeout(() => {
                            (this.$parent.$parent as any).AddModalClose(false);
                            this.$nextTick(() => {
                                (this.$parent.$parent as any).AddModalClose(true);
                            });
                        }, 1000);
                    }
                }
            });
        }
        //跳转外协单位管理
        ToOutUnit() {
            this.$router.push({
                name: 'outsideUnitManage',
                query: {
                    isContractComing: '1'
                }
            })
        }
        //动态加载二级部门
        LoadSecondOrganization(id:any) {
            if(id == undefined){
                return;
            }
            Ajax.get('/api/services/app/Organization/GetAllChildrenOrganizationByParentIdAsync?id='+id).then((res:any)=>{
                this.$set(this.initData.dicData, 'allSecondOrganization', res.data.result);
            });
        }
        //获取地区所有信息
        GetAllRegions(){
            Ajax.get('/api/services/app/Region/GetAllRegions').then((res:any)=>{
                this.$set(this.initData.dicData, 'area', res.data.result);
            });
        }
        //获取字典数据
        async GetDic() {
            //所有字典
            await this.$store.dispatch('project/GetAllDictionary');
            //外协合同  合同分类
            Ajax.get('/api/services/app/SysBaseData/GetCatalogItemAsync?DirectoryCode=EXCT').then((res:any)=>{
                this.initData.wxProjectType = res.data.result.items;
            });
            //单位字典
            await this.$store.dispatch('project/GetbearerUnit');
            //外协单位
            await this.$store.dispatch('project/GetAllExternalUnit');
            //部门字典
            await this.$store.dispatch('project/GetContractBelongOrg');
            //项目类别字典
            await this.$store.dispatch('project/GetAllProjectCatalog');
            //获取所有用户数据
            await this.$store.dispatch('project/GetAllUser');
            this.$store.state.project.allDictionary.map((item:any) => {
                this.$set(this.initData.dicData, item.key, item.items.map((items:any) => {
                    return {
                        label: items.displayName,
                        value: items.id
                    }
                }));
            });
            //获取所有区域
            await this.$store.dispatch('project/GetArea');
            // this.initData.dicData.area = this.$store.state.project.allArea.map( (item:any) => {
            //     return {
            //         value: item.value,
            //         label: item.label,
            //         children: item.children,
            //         loading: false,
            //     }
            // } );
            
            this.GetAllRegions();
            //当前登录用户数据
            await this.$store.dispatch({type: 'session/init'});
            // await this.GetAllRegions();
            //合同签订人查询特殊接口
            await this.$store.dispatch({type: 'project/GetAllPersonNoPermission'});           
            this.initData.dicData.bearerUnit = this.$store.state.project.bearerUnitId;
            this.initData.dicData.externalUnit = this.$store.state.project.externalUnit;
            this.initData.dicData.bearerOrg = this.$store.state.project.contractBelongOrg;
            this.initData.dicData.projectCatalog = this.$store.state.project.projectCatalog;
            this.initData.dicData.userList = this.$store.state.project.userList;
            this.initData.dicData.allPersonNoPermission = this.$store.state.project.allPersonNoPermission;
            if(!this.$route.query.id){
                this.initData.formData.agentUserId = this.$store.state.session.user ? this.$store.state.session.user.id == 2 ? null : this.$store.state.session.user.id : null;
            }
            this.initData.formData.belongOrgId = this.$store.state.session.user ? this.$store.state.session.user.organization.id : null;
            if(this.initData.formData.belongOrgId) this.LoadSecondOrganization(this.initData.formData.belongOrgId);
        }
        //重置表单
        RestForm(status:any) {
            if(status) return;
            (this.$refs.contractAddForm as any).resetFields();
            this.initData.formData = {}
            this.initData.formData.agentUserId = this.$store.state.session.user ? this.$store.state.session.user.id : null;
            this.initData.formData.belongOrgId = this.$store.state.session.user ? this.$store.state.session.user.organization.id : null;
        }

        //验证规则
        rules:any = {
            projectCatalogId: [{ required: true, type: 'number', message: '请选择合同类型', trigger: 'change' }],
            externalContractType: [{ required: true, type: 'number', message: '请选择合同类型', trigger: 'change' }],
            contractName: [{ required: true, message: '请填写合同名称', trigger: 'blur' }],
            externalUnitId: [{ required: true, type: 'number', message: '请选择外协单位', trigger: 'change' }],
            signUnitId: [{ required: true, type: 'number', message: '请选择签订单位', trigger: 'change' }],
            ownerUnit: [{ required: true, message: '请填写业主单位', trigger: 'blur' }],
            fundsSource: [{ required: true, type: 'number', message: '请选择资金来源', trigger: 'change' }],
            contractAmount: [{ required: true, type: 'number', message: '请填写合同金额', trigger: 'change' }],
            advancePayment: [{ required: true, type: 'number', message: '请填写预付款金额', trigger: 'change' }],
            projectCatalog: [{ required: true, type: 'number', message: '请选择项目类别', trigger: 'change' }],
            externalProjectType: [{ required: true, type: 'number', message: '请选择项目类别', trigger: 'change' }],
            signDt: [{ required: true, message: '请选择合同签订日期'}],
            keepOnRecordDt: [{ required: true, message: '请选择合同备案日期'}],
            beginDt: [{ required: true, message: '请选择合同起始日期'}],
            endDt: [{ required: true, message: '请选择合同截止日期'}],
            contractSignUserId: [{ required: true, type: 'number', message: '请填写合同签订人', trigger: 'change' }],
            // externalSignUserId: [{ required: true, type: 'number', message: '请选择合同签订人', trigger: 'change' }],
            contractProjectLeaderId: [{ required: true, type: 'number', message: '请选择项目负责人', trigger: 'change' }],
            belongOrgId: [{ required: true, type: 'number', message: '请选择所属部门', trigger: 'change' }],
            agentUserId: [{ required: true, type: 'number', message: '请填写经办人', trigger: 'change' }],
            sealCount: [{ required: true,type: 'number', message: '请填写盖章份数', trigger: 'blur' }],
            fieldConstructionFinishDt: [{ required: true, message: '请选择野外施工结束日期'}],
            fieldAcceptanceDt: [{ required: true, message: '请选择野外验收日期'}],
            reportReviewFilingDt: [{ required: true, message: '请选择报告评审备案日期'}],
            dataExchangeDt: [{ required: true, message: '请选择资料汇交日期'}],
            submitFinalAccountDt: [{ required: true, message: '请选择提交决算申请日期'}],
            contractAmountExplain: [{ required: true, message: '请填写合同金额说明', trigger: 'blur' }],
            noTimelimitExplain: [{ required: true, message: '请填写无工期合同说明', trigger: 'blur' }],
            isBackFormalContract: [ { required: true, message: '请选择是否盖章', trigger: 'change' } ],
        }
        //编辑弹窗
        //更新数据
        @Watch('editData')
        editDataChange(newVal:any, oldVal:any){
            let tempVal = newVal;
            tempVal.isReportStamped = tempVal.isReportStamped == true ? 1 : 0;
            tempVal.signUnitId = tempVal.signUnit ? tempVal.signUnit.id : null;
            tempVal.belongOrgId = tempVal.belongOrg ? tempVal.belongOrg.id : null;
            if(tempVal.belongOrgId) this.LoadSecondOrganization(tempVal.belongOrgId);
            tempVal.projectCatalogId = tempVal.projectCatalog ? tempVal.projectCatalog.id : null;
            tempVal.contractId = tempVal.contractId ? tempVal.contractId : null;
            tempVal.agentUserId = tempVal.agentUser ? tempVal.agentUser.id : null;
            tempVal.contractProjectLeaderId = tempVal.contractProjectLeader ? tempVal.contractProjectLeader.id == 2 ? null : tempVal.contractProjectLeader.id : null;
            if(tempVal.attachs && tempVal.attachs.length >= 1){
                tempVal.attachsFormal = tempVal.attachs.map((item:any)=>{
                    return {
                        attachName: item.attachName,
                        name: item.attachName,
                        fileId: item.fileId,
                        url: item.url,
                        isFormal: true
                    }
                });
            }
            tempVal.attachs = [];
            if(tempVal.members == null){
                tempVal.members = [{
                    belongOrgUnit: '',
                    memberName: '',
                    index: 1
                }]
            }
            //项目所在地区
            if(tempVal.province){
                let areaArry:any = [];
                if(tempVal.province) {
                    areaArry.push(tempVal.province.id);
                }
                if(tempVal.city) {
                    areaArry.push(tempVal.city.id);
                }
                if(tempVal.county) {
                    areaArry.push(tempVal.county.id);
                }
                this.$nextTick(() => {
                    this.$set(tempVal,'area',areaArry);
                });
            }
            // 特殊合同部门领导签字
            if(tempVal.departSignLeader) {
                tempVal.departSignLeaderId = tempVal.departSignLeader.id;
            }
            // 特殊合同二级部门
            if(tempVal.secondBelongOrg) {
                this.$nextTick(() => {
                    setTimeout( () => {
                        this.$set(tempVal,'secondBelongOrgId',tempVal.secondBelongOrg.id);
                    }, 500 )
                });
            }
            // 日期格式化
            tempVal.beginDt = tempVal.beginDtLocal ? tempVal.beginDtLocal : null;
            tempVal.endDt = tempVal.endDtLocal ? tempVal.endDtLocal : null;
            tempVal.archieveDt = tempVal.archieveDtLocal ? tempVal.archieveDtLocal : null;
            tempVal.completeDt = tempVal.completeDtLocal ? tempVal.completeDtLocal : null;
            tempVal.keepOnRecordDt = tempVal.keepOnRecordDtLocal ? tempVal.keepOnRecordDtLocal : null;
            tempVal.signDt = tempVal.signDtLocal ? tempVal.signDtLocal : null;
            tempVal.stampeDt = tempVal.stampeDtLocal ? tempVal.stampeDtLocal : null;
            tempVal.isBackFormalContract = tempVal.isBackFormalContract  ? tempVal.isBackFormalContract == 'false' ? 'false' : 'true' : 'false';
            this.initData.formData = tempVal;
            this.initData.formData.secondBearerOrgId = this.initData.formData.secondBearerOrgId == '' ? null : this.initData.formData.secondBearerOrgId;
        }
        //补充协议
        @Watch('mainContractData')
        mainContractDataChange(newVal:any, oldVal:any){
            this.initData.formData.contractName = newVal.contractName + '补充协议';
            this.initData.formData.ownerUnit = newVal.ownerUnit;
            this.initData.formData.fundsSource = newVal.fundsSource;
            this.initData.formData.sealCount = null;
            console.log(this.initData.formData)
        }
        async mounted() {
            this.initData.loading = true;
            await this.GetDic();
            this.initData.loading = false;
        }
    }
